import React from 'react';

import clsx from 'clsx';

import styles from './FormBody.module.scss';

export interface FormBodyProps extends React.PropsWithChildren<{}> {
  onSubmit?: () => void;
  formBodyClassName?: string;
}

const FormBody = ({ onSubmit, formBodyClassName, children }: FormBodyProps) => (
  <form id="form" className={clsx(styles.formBody, formBodyClassName)} onSubmit={onSubmit}>
    {children}
  </form>
);

export default FormBody;
